module.exports = __webpack_public_path__ + "static/media/video-step-1.0cf863e6.png";